import React, { Component } from 'react'
import { TABLE_DISTRIBUCION_POR_CONDICION } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaDistribucionPorCondicionView extends Component {
  render () {
    return (
      <MuiTable id={TABLE_DISTRIBUCION_POR_CONDICION} />
    )
  }
}
